import React from "react"
import { CardContentWrapper, CardWrapper } from "../../../../Cards/base"
import BMICardHeading from "./BMICardHeading"
import SeekChart from "./SeekChart"
import { BMILevel } from "../../BMILevel"

const LabelToLevelOfBMI: React.FC<{
  show: boolean
  valueOfBMI: number
  bgColor: string
}> = ({ bgColor, valueOfBMI, show }) => {
  if (!show) return null

  let bmiLevel = BMILevel[BMILevel.length - 1]
  for (let i = BMILevel.length - 1; i >= 0; i--) {
    let level = BMILevel[i]
    if (valueOfBMI >= level.lt) break
    bmiLevel = level
  }

  return (
    <div className="mt-4 text-right text-sm text-blue-800">
      <span
        className={`ml-2 tracking-wide text-blue-100 py-1 px-3 rounded-full ${bgColor}`}
      >
        {bmiLevel.label}
      </span>
    </div>
  )
}

const BMICardView: React.FC<{
  valueOfBMI: number
  enable: boolean
  seekPosition: number
  seekColorClass: string
}> = ({ valueOfBMI, enable, seekPosition, seekColorClass }) => (
  <CardWrapper className="hover:shadow-none">
    <BMICardHeading enable={enable} bmi_value={valueOfBMI} />
    <CardContentWrapper>
      <SeekChart
        percentageFromLeft={seekPosition}
        valueOnSeek={valueOfBMI.toFixed(1)}
        seekColorClass={seekColorClass}
      />
      <LabelToLevelOfBMI
        show={enable}
        valueOfBMI={valueOfBMI}
        bgColor={seekColorClass}
      />
    </CardContentWrapper>
  </CardWrapper>
)

const BMICard: React.FC<{ height: number | null; weight: number | null }> = ({
  height,
  weight,
}) => {
  const MIN_BMI = 15.5 // Defined by the App's specifications
  const MAX_BMI = 42 // Same as above

  let valueOfBMI = 0
  let seekColorClass = "bg-gray-700"
  if (height && weight) {
    valueOfBMI = (weight * 10000) / height / height
    seekColorClass = "bg-site-blue"
  }
  const seekPositionInPercentage =
    (100 * (valueOfBMI - MIN_BMI)) / (MAX_BMI - MIN_BMI)

  return (
    <BMICardView
      valueOfBMI={valueOfBMI}
      enable={Boolean(valueOfBMI)}
      seekPosition={seekPositionInPercentage}
      seekColorClass={seekColorClass}
    />
  )
}

export default BMICard
